//import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import IconButton from "@material-ui/core/IconButton";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import InputAdornment from "@material-ui/core/InputAdornment";
import Drawer from "@material-ui/core/Drawer";
import Grid from "@material-ui/core/Grid";
// import Grow from "@material-ui/core/Grow";
// import MenuItem from "@material-ui/core/MenuItem";
// import MenuList from "@material-ui/core/MenuList";
// import Paper from "@material-ui/core/Paper";
// import Popper from "@material-ui/core/Popper";
import withStyles from "@material-ui/core/styles/withStyles";
//import Tooltip from "@material-ui/core/Tooltip";
import TextField from "@material-ui/core/TextField";
import classNames from "classnames";
import get from "lodash/get";
import Button from "@material-ui/core/Button";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import DynamicForm from "Component/DynamicForm";
// import parentdepartmentIcon from "Assets/newicons/app/profile/outline/parent-department.svg";
// import emailIcon from "Assets/newicons/user-interface/mail/outline/mail-outline-16px.svg";
import DrawerHeader from "Component/Headers/drawerHeader";
import { checkboxinputconverter } from "Component/DynamicForm/Fields/CheckBox";

import {
  instance,
  instanceMultipart,
} from "../../../../../Actions/AxiosInstance";
import { refreshProfileInfo } from "../../../../../Actions/commonAction";
import loader from "../../../../../Assets/Gif/loader.gif";
// import department from "../../../../../Assets/Icons/Department/department-16px.svg";
// import designation from "../../../../../Assets/Icons/Designation/designation-16px.svg";
// import empId from "../../../../../Assets/Icons/EmployeeId/emp-id-16px.svg";
// import phone from "../../../../../Assets/Icons/Phone/phone-16px.svg";
// import team from "../../../../../Assets/Icons/Team/team-16px.svg";
// import If from "../../../../../Component/Common/If";
import createstore from "../../../../../store";
import { getFormattedImageLink, getFormattedDate, } from "../../../../../Utils";
import Resignation from "./Resignation";
// import defaultEmp from "../../../../../Assets/Images/defaultEmp.svg";
// import { FEATUREKEYS } from "../../../../../Constants/Featurekeys";
// import { AvatarPicker } from "./AvatarPicker";


// const styles = (theme) => ({

//   root: {
//     flexGrow: 1,
//   },
// });

const styles = (theme) => ({
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    height: 56,
  },
  leadloginbutton: {
    width: 200,
    height: 56,
  },
  dense: {},
  padding30: {
    padding: 30,
  },
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: "hidden",
    position: "relative",
    display: "flex",
  },
  padding40: {
    padding: 0,
  },
  drawerPaper: {
    width: "30%",
  },
});

function LabelValue({ label, value }) {
  return (
    <div className="margin-bottom-8">
      <p className="t-14 normal-dark-secondary floatleft">{label}</p>
      <p className="t-14 normal-dark-secondary floatright t-bold margin-right-4">
        {value}
      </p>
      <div className="clear-float"></div>
    </div>
  );
}

class EmpActions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      accountid: "",
      subscriptionid: "",
      showPassword: false,
      countrytimezoneid: "",
      employeeid: "",
      ProfileBasicInfo1: {},
      Appreciation: {},
      ProfileImg: "",
      colleagueid: null,
      apprcount: 0,
      AppreciationList: {},
      openOptions: false,
      openDrawer: false,
      exitpolicyid: null,
      showResign: false,
      allowselfresign: false,
      reactivateDrawer: false,
      resetPasswordDrawer: false,
      reActivateEmployeeData: [],
      newpassword: null,
      isnotify: false,
    };
    this.openOptions = this.openOptions.bind(this);
    this.toggleDrawer = this.toggleDrawer.bind(this);
    this.reActivateEmployeeData = this.reActivateEmployeeData.bind(this);
    this.onReActivate = this.onReActivate.bind(this);
    this.onResetPassword = this.onResetPassword.bind(this);
    this.initiateResignation = this.initiateResignation.bind(this);
    this.resetPassword = this.resetPassword.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    // this.props.ChangeLanguage("");
    const { SubscriptionInfo } = createstore.getState();
    // let AuthenticationAction = createstore.getState().AuthenticationAction;
    const { accountid } = SubscriptionInfo.SubscriptionData;
    const { subscriptionid } = SubscriptionInfo.SubscriptionData;
    const { countrytimezoneid } = SubscriptionInfo.SubscriptionData;

    let employeeid;
    let masterprofileid;
    employeeid = SubscriptionInfo.SubscriptionData.employeeid;

    const { AuthenticationAction } = createstore.getState();
    if (AuthenticationAction.IsFulfilled) {
      employeeid = AuthenticationAction.login.employeeid;
      masterprofileid = AuthenticationAction.login.masterprofileid;
    }
    const { colleagueid } = this.props.match.params;
    const isoutsideapp = this.props.match.path.indexOf("newemployee") !== -1;
    console.log("isoutsideapp: ", isoutsideapp);

    const { permissions } = this.props;
    let hideButton;
    isoutsideapp
      ? (hideButton = false)
      : permissions.editable
        ? colleagueid && colleagueid != employeeid
          ? masterprofileid != 9
            ? (hideButton = true)
            : (hideButton = false)
          : (hideButton = false)
        : masterprofileid != 9
          ? (hideButton = true)
          : (hideButton = false);
    this.setState(
      {
        accountid,
        subscriptionid,
        countrytimezoneid,
        employeeid,
        colleagueid,
        hideButton,
        isoutsideapp,
        showResign:
          AuthenticationAction.login && AuthenticationAction.login.isowner
            ? colleagueid && colleagueid != AuthenticationAction.login.employeeid
              ? true
              : false
            : !isoutsideapp,
      },
      () => {
         this.GetProfileBasicInfo1();
        // this.GetSocialMediaLinks();
        !isoutsideapp &&
          AuthenticationAction.login &&
          (!AuthenticationAction.login.isowner ||
            (AuthenticationAction.login.isowner && colleagueid && colleagueid != AuthenticationAction.login.employeeid)) &&
          this.getResignationOn();
        // if (colleagueid && colleagueid != employeeid) {
        //   this.GetEmployeeDetails(colleagueid);
        // }
      },
    );
  }

  componentWillReceiveProps(props) {
    if (props.refreshProfileInfoReducer.doRefresh) {
      this.GetProfileBasicInfo1();
    }
    let employeeid;
    let masterprofileid;
    const { AuthenticationAction } = createstore.getState();
    if (AuthenticationAction.IsFulfilled) {
      employeeid = AuthenticationAction.login.employeeid;
      masterprofileid = AuthenticationAction.login.masterprofileid;
    } else {
      const { SubscriptionInfo } = createstore.getState();
      employeeid = SubscriptionInfo.SubscriptionData.employeeid;
    }
    const { permissions } = this.props;
    const { colleagueid } = this.props.match.params;
    const isoutsideapp = this.props.match.path.indexOf("newemployee") !== -1;
    let hideButton;
    isoutsideapp
      ? (hideButton = false)
      : permissions.editable
        ? colleagueid && colleagueid != employeeid
          ? masterprofileid != 9
            ? (hideButton = true)
            : (hideButton = false)
          : (hideButton = false)
        : masterprofileid != 9
          ? (hideButton = true)
          : (hideButton = false);
    this.setState({ hideButton });
    if (
      this.state.colleagueid === null ||
      this.state.colleagueid != props.match.params.colleagueid
    ) {
      this.setState({ colleagueid }, () => {
        if (colleagueid != employeeid) {
          this.GetProfileBasicInfo1();
          // this.GetSocialMediaLinks();
        }
      });
    }
  }

  handleClickShowPassword = () => {
    this.setState((state) => ({ showPassword: !state.showPassword }));
  };

  // OnFieldChange() {
  //   console.log("hello");
  // }

  // passwordKeyPress() {
  //   console.log("testing done");
  // }

  handleChange(value, key) {
    if (key == "newpassword") {
      this.setState({
        [key]: value.target.value,
      });
    } else {
      this.setState({
        [key]: value,
      });
    }
    console.log("testing done");
  }

  getResignationOn() {
    instance
      .get(
        `exit/isexitactionallowed/${
        this.state.colleagueid
          ? this.state.colleagueid
          : this.state.employeeid
        }`,
      )
      .then((result) => {
        this.setState({
          showResign: (result.data.result[0] && result.data.result[0].isallowed) || false,
          exitpolicyid: (result.data.result[0] && result.data.result[0].exitpolicyid) || null,
        });
      });
  }

  toggleDrawer(value) {
    this.setState({ openDrawer: value });
  }

  getappreaciationCount() {
    let apprcount = 0;
    this.state.AppreciationList.map((cnt) => (apprcount += cnt.count));
    this.setState({ apprcount });
  }

  GetProfileBasicInfo1() {
    const URL = "/employee/empaboutme";
    let data;
    if (createstore.getState().AuthenticationAction.IsFulfilled) {
      if (this.state.colleagueid) {
        data = {
          employeeid: this.state.colleagueid,
        };
      } else {
        data = {};
      }
    } else {
      data = {
        accountid: this.state.accountid,
        subscriptionid: this.state.subscriptionid,
        timezoneid: this.state.countrytimezoneid,
        employeeid: this.state.employeeid,
      };
    }
    instance
      .post(URL, data)
      .then((result) => {
        let ProfileBasicInfo1 = [];
        result.data.result.length != 0
          ? (ProfileBasicInfo1 = result.data.result[0])
          : (ProfileBasicInfo1 = []);
        const ProfileImg =
          ProfileBasicInfo1.imagepath &&
          `${ProfileBasicInfo1.imagepath}?${Date.now()}`;
        this.setState({ ProfileBasicInfo1, ProfileImg });
        this.props.refreshProfileInfo(false);
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  UpdateAppreciation() {
    if (this.state.employeeid != this.state.colleagueid) {
      const data = {
        employeeid: this.state.colleagueid,
      };
      const URL = "employee/insertempappreciation";
      instance
        .post(URL, data)
        .then(() => {
          let count = this.state.Appreciation.count
            ? this.state.Appreciation.count
            : 0;
          count += 1;
          const Appreciation = {};
          Appreciation.count = count;
          this.setState({ Appreciation, apprcount: count });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    }
  }

  onReActivate() {
    this.props.enqueueSnackbar("Are you sure you want to reactivate this employee?", {
      variant: "warning",
      action: [
        <Button
          key="key"
          color="inherit"
          size="small"
          onClick={() => {
            const data = {
              employeeid: this.state.colleagueid
                ? this.state.colleagueid
                : this.state.employeeid,
            };
            this.props.closeSnackbar();
            instance.post('employee/reactivateemployee', data).then((result) => {
              this.setState({
                reactivateDrawer: false,
                reActivateEmployeeData: [],
              });
              this.props.enqueueSnackbar("Reactivated successfully", { variant: 'success' });
              //this.GetProfileBasicInfo1();
            }).catch((error) => {
              const msg = error.response && error.response.data && error.response.data.error.message;
              this.props.enqueueSnackbar(msg || "", {
                variant: "error",
              });
              // this.setState({

              //   createmenu: false,
              // });
            });
          }}
        >
          Yes
        </Button>,
        <Button key="key" color="inherit" size="small" onClick={() =>
          this.setState({ createmenu: false }, () =>
            this.props.closeSnackbar())
        } >
          No
        </Button>,
      ],
    });
  }

  onResetPassword() {
    const data = {
      employeeid: this.state.colleagueid
        ? this.state.colleagueid
        : this.state.employeeid,
      newpassword: this.state.newpassword,
      isnotify: this.state.isnotify,
    };
    instance.post('account/updateuserpassword', data).then((result) => {
      this.setState({
        resetPasswordDrawer: false,
        newpassword: null,
        isnotify: false,
  showPassword: false,
      });
      this.props.enqueueSnackbar("successfully updated", { variant: 'success' });
    }).catch((error) => {
      const msg = error.response && error.response.data && error.response.data.error.message;
      this.props.enqueueSnackbar(msg || "", {
        variant: "error",
      });
    });
  }

  OpenEmpList() {
    this.props.OpenEmpList();
  }

  // GetSocialMediaLinks() {
  //   const URL = "employee/getempallcontact";
  //   let data;
  //   if (createstore.getState().AuthenticationAction.IsFulfilled) {
  //     if (this.state.colleagueid) {
  //       data = {
  //         employeeid: this.state.colleagueid,
  //       };
  //     } else {
  //       data = {};
  //     }
  //   } else {
  //     data = {
  //       accountid: this.state.accountid,
  //       subscriptionid: this.state.subscriptionid,
  //       timezoneid: this.state.countrytimezoneid,
  //       employeeid: this.state.employeeid,
  //     };
  //   }
  //   instance
  //     .post(URL, data)
  //     .then((result) => {
  //       const socialmediaLinks = result.data.result;
  //       let facebook;
  //       let twitter;
  //       let mail;
  //       let mobile;
  //       for (const obj of socialmediaLinks) {
  //         if (obj.contacttypeid == 8) {
  //           facebook = obj.contacttypevalue;
  //         }
  //         if (obj.contacttypeid == 9) {
  //           twitter = obj.contacttypevalue;
  //         }
  //         if (obj.contacttypeid == 1) {
  //           mail = obj.contacttypevalue;
  //         }
  //         if (obj.contacttypeid == 2) {
  //           mobile = obj.contacttypevalue;
  //         }
  //       }
  //       if (facebook) {
  //         const x = facebook.search("http");
  //         facebook = x == -1 ? `https://${facebook}` : null;
  //       }
  //       if (twitter) {
  //         const y = twitter.search("http");
  //         twitter = y == -1 ? `https://${twitter}` : null;
  //       }
  //       if (mail) {
  //         const z = mail.search("http");
  //         mail = z == -1 ? `https://${mail}` : null;
  //       }

  //       const facebookUrl = facebook;
  //       const twitterUrl = twitter;
  //       const mailUrl = mail;
  //       this.setState({
  //         facebookUrl,
  //         twitterUrl,
  //         mailUrl,
  //         facebook,
  //         twitter,
  //         mail,
  //         mobile,
  //       });
  //     })
  //     .catch((error) => {
  //       const CommonError = error.response
  //         ? error.response.data.error.message
  //         : error.message;
  //       this.props.enqueueSnackbar(CommonError, { variant: "error" });
  //     });
  // }

  // profileUpload(e) {
  //   const file = e.target.files[0];
  //   let extFile;
  //   if (file) {
  //     const img = file.name.split(";");
  //     const imgname = img[0];
  //     const idxDot = imgname.lastIndexOf(".") + 1;
  //     extFile = imgname.substr(idxDot, imgname.length).toLowerCase();
  //   }

  //   if (file && file.size > 2097152) {
  //     this.props.enqueueSnackbar(
  //       "Please Upload Valid Size Image (Maxsize : 2MB)",
  //       {
  //         variant: "error",
  //       },
  //     );
  //   } else if (
  //     !(
  //       extFile == "png" ||
  //       extFile == "jpg" ||
  //       extFile == "jpeg" ||
  //       extFile == "svg+xml"
  //     )
  //   ) {
  //     this.props.enqueueSnackbar("Please Upload valid image", {
  //       variant: "error",
  //     });
  //   } else {
  //     // let URL = '/upload/profile';
  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       this.setState({
  //         // file: e.target.files[0],
  //         ProfileImg: reader.result,
  //       });
  //     };
  //     reader.readAsDataURL(file);
  //     let employeeid;
  //     if (createstore.getState().AuthenticationAction.IsFulfilled) {
  //       const { AuthenticationAction } = createstore.getState();
  //       employeeid = AuthenticationAction.login.employeeid;
  //     } else {
  //       employeeid = this.state.employeeid;
  //     }
  //     const { colleagueid } = this.props;
  //     const URL = `/employee/profile/${this.props.SubscriptionData.accountid}/${
  //       this.props.SubscriptionData.subscriptionid
  //       }/${colleagueid || employeeid}/${
  //       this.props.SubscriptionData.countrytimezoneid
  //       }`;

  //     const formData = new FormData();
  //     if (createstore.getState().AuthenticationAction.IsFulfilled) {
  //       formData.append("file", file);
  //     } else {
  //       formData.append("file", file);
  //       formData.append("employeeid", this.state.employeeid);
  //       formData.append("accountid", this.state.accountid);
  //       formData.append("subscriptionid", this.state.subscriptionid);
  //       formData.append("timezoneid", this.state.countrytimezoneid);
  //     }
  //     // formData.append('employeeid', 16)
  //     this.setState({ ProfileImg: loader });

  //     instanceMultipart
  //       .post(URL, formData)
  //       .then((result) => {
  //         if (result.data.result) {
  //           const imgObj = result.data.result[0].imagesArray.find(
  //             (x) => x.imagetype == 4,
  //           );
  //           this.setState({ ProfileImg: `${imgObj.imagepath}?${Date.now()}` });
  //           this.props.enqueueSnackbar("Saved successfully", {
  //             variant: "success",
  //           });
  //         }
  //       })
  //       .catch((error) => {
  //         const CommonError = error.response
  //           ? error.response.data.error.message
  //           : error.message;
  //         this.props.enqueueSnackbar(CommonError, { variant: "error" });
  //       });
  //   }
  // }

  initiateResignation() {
    if (this.state.ProfileBasicInfo1.stageid == 5) {
      this.props.enqueueSnackbar("your notice period already started", {
        variant: "error",
      });
    } else if (this.state.ProfileBasicInfo1.stageid == 6 || this.state.ProfileBasicInfo1.stageid == 7) {
      this.props.enqueueSnackbar("Employee is already Inactivated", {
        variant: "error",
      });
    } else {
      this.toggleDrawer(true);
    }
  }


  reActivateEmployeeData() {
    // const { employeeid } = this.state;
    instance.get(`employee/getreactivateemployeedetail/${this.state.colleagueid
      ? this.state.colleagueid
      : this.state.employeeid}`).then((result) => {
        this.setState({
          reActivateEmployeeData: result.data.result[0],
          reactivateDrawer: true,
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  resetPassword() {
    this.setState({
      // reActivateEmployeeData: result.data.result[0],
      resetPasswordDrawer: true,
    });
  }

  openOptions(value) {
    this.setState({ openOptions: value });
  }

  render() {
    const { classes } = this.props;
    const {
      ProfileBasicInfo1,
      //openOptions,
      openDrawer,
      showResign,
      exitpolicyid,
     // hideButton,
    } = this.state;
    console.log('ProfileBasicInfo1,: ', ProfileBasicInfo1);
    const {
      firstname = "",
      middlename = "",
      lastname = "",
      // designationname,
      // departmentname,
      // teamname = "",
      // parentdepartmentname = "",
      // email,
      // primarymobile,
      employeecode,
    } = ProfileBasicInfo1;
    const fullname = `${firstname || ""} ${middlename || ""} ${lastname || ""}`;
    // const checkresigallow = get(this.props, "AuthenticationAction.login.features", []).find((feature) => feature.featureid == FEATUREKEYS.initiateResignation);
    const empcode = employeecode ? employeecode : "-";
    const isProfileEditAllowed =
      !get(this.props, "colleagueid", "") ||
      get(this.props, "AuthenticationAction.login.masterprofileid", "") >= 9;
    console.log('this.state.reActivateEmployeeData: ', this.state.reActivateEmployeeData);
    // const showResign = !this.props.history.location.pathname.includes("completeprofile") && isProfileEditAllowed && checkresigallow;
    return (
      <div style={{paddingTop:10}}>
        {/* <Grid container className="display-flex"> */}
         
          {((this.props.AuthenticationAction && this.props.AuthenticationAction.login && this.props.AuthenticationAction.login.masterprofileid == 9) || showResign || ((ProfileBasicInfo1.stageid == 6 || ProfileBasicInfo1.stageid == 7) && (this.props.AuthenticationAction && this.props.AuthenticationAction.login && this.props.AuthenticationAction.login.masterprofileid == 9)) || ((this.props.AuthenticationAction && this.props.AuthenticationAction.login && this.props.AuthenticationAction.login.masterprofileid == 9 ) && ProfileBasicInfo1.isselfservice == true)) && (
            <Grid item xs={12} md={1} sm={2}>
              {/* <div
                onClick={() => this.openOptions(true)}
                className="profile-more-options-icon"
              >
                <i className="material-icons floatleft">more_vert</i> */}
                {/* <Popper
                  open={openOptions}
                  anchorEl={this.anchorEl}
                  transition
                  disablePortal
                  className="profile-more-options"
                > */}
                  {/* {({ TransitionProps, placement }) => (
                    <Grow
                      {...TransitionProps}
                      style={{
                        transformOrigin:
                          placement === "bottom" ? "right top" : "right bottom",
                      }}
                    > */}
                      {/* <Paper> */}
                        {/* <ClickAwayListener
                          onClickAway={() => this.openOptions(false)}
                        > */}
                          {/* <MenuList> */}
                          <table>
                            <tr>
                            {(showResign || (exitpolicyid != null && this.props.AuthenticationAction && this.props.AuthenticationAction.login.masterprofileid == 9)) && 
                            <td>
                            <button class="btn btn-primary-md-blue" style={{width: 201 , display: "inline-block", textAlign: "center", borderRadius:5,
                            border: "none"}} onClick={() => this.initiateResignation()
                            }>
                              Initiate Resignation
                            </button>
                            </td>
                            }
                            
                            {this.props.AuthenticationAction.login.masterprofileid == 9 && (ProfileBasicInfo1.stageid == 6 || ProfileBasicInfo1.stageid == 7) &&
                            <td>  
                            <Button class="btn btn-primary-md-blue" style={{width: 201 , display: "inline-block", textAlign: "center", borderRadius:5,
                              border: "none"}}
                                onClick={() =>
                                  this.reActivateEmployeeData()
                                }
                              >
                                Re-activate employee
                            </Button>
                            </td>
                            }
                            {this.props.AuthenticationAction.login.masterprofileid == 9 && ProfileBasicInfo1.isselfservice == true && this.state.colleagueid && (this.state.colleagueid != this.state.employeeid) &&
                            <td>
                            <Button class="btn btn-primary-md-blue" style={{width: 140 , display: "inline-block", textAlign: "center", borderRadius:5,
                              border: "none"}}
                                onClick={() =>
                                  this.resetPassword()
                                }
                              >
                                 Set password
                            </Button>
                            </td>
                            } 
                            </tr>
                            </table>
                          {/* </MenuList> */}
                        {/* </ClickAwayListener> */}
                      {/* </Paper> */}
                    {/* </Grow>
                  )} */}
                {/* </Popper> */}
              {/* </div> */}
            </Grid>
          )}
        {/* </Grid> */}
        <Drawer
          anchor="right"
          open={openDrawer}
          onClose={() => this.toggleDrawer(false)}
          classes={{
            paper: classNames(classes.drawerPaper),
          }}
        >
          {openDrawer && (
            <Resignation {...this.props} toggleDrawer={this.toggleDrawer} />
          )}
        </Drawer>
        <Drawer
          anchor="right"
          open={this.state.reactivateDrawer}
          onClose={() => this.setState({ reactivateDrawer: false })}
          classes={{
            paper: classNames(classes.drawerPaper),
          }}
        >
          <div style={{ padding: 16 }}>
            <DrawerHeader
              header="Re-activate employee"
              isbackarrow={false}
              closeDrawer={() => this.setState({ reactivateDrawer: false })}
            />
            {this.state.reactivateDrawer && (
              <div>
                {this.state.reActivateEmployeeData && (
                  // this.state.reActivateEmployeeData.map((cycle) => (
                  <>
                    <div
                      style={{
                        backgroundColor: "#f7f8f8",
                        marginBottom: 16,
                        padding: 8,
                      }}
                    >
                      <LabelValue
                        label="Employee name"
                        value={
                          this.state.reActivateEmployeeData.fullname == null ||
                          this.state.reActivateEmployeeData.fullname == ""
                            ? ""
                            : `${this.state.reActivateEmployeeData.fullname}`
                        }
                      />
                      {/* // )} */}
                      {/* {this.state.reActivateEmployeeData.doj && ( */}
                      <LabelValue
                        label="Date of joining"
                        value={
                          this.state.reActivateEmployeeData.doj == null ||
                          this.state.reActivateEmployeeData.doj == ""
                            ? ""
                            : `${getFormattedDate(
                                this.state.reActivateEmployeeData.doj,
                              )}`
                        }
                      />
                      {/* // )} */}
                      {/* {this.state.reActivateEmployeeData.exitdate && ( */}
                      <LabelValue
                        label="Exit date"
                        value={
                          this.state.reActivateEmployeeData.exitdate == null ||
                          this.state.reActivateEmployeeData.exitdate == ""
                            ? ""
                            : `${getFormattedDate(
                                this.state.reActivateEmployeeData.exitdate,
                              )}`
                        }
                      />
                      {/* )} */}
                      {/* {this.state.reActivateEmployeeData.noticedate && ( */}
                      <LabelValue
                        label="Notice date"
                        value={
                          this.state.reActivateEmployeeData.noticedate ==
                            null ||
                          this.state.reActivateEmployeeData.noticedate == ""
                            ? ""
                            : `${getFormattedDate(
                                this.state.reActivateEmployeeData.noticedate,
                              )}`
                        }
                      />
                      {/* )} */}
                      <LabelValue
                        label="FNF Status"
                        value={`${
                          this.state.reActivateEmployeeData.isprocessefnf
                            ? "Done"
                            : "Not Done"
                        }`}
                      />
                       <LabelValue
                        label="Deactivated on"
                        value={(this.state.reActivateEmployeeData.deactivatedon == null || this.state.reActivateEmployeeData.deactivatedon == "") ? "" : `${getFormattedDate(this.state.reActivateEmployeeData.deactivatedon)}`}
                      />
                       <LabelValue
                        label="Deactivated by"
                        value={(this.state.reActivateEmployeeData.deactivatedby == null || this.state.reActivateEmployeeData.deactivatedby == "") ? "" : `${this.state.reActivateEmployeeData.deactivatedby}`}
                      />
                    </div>

                    <div>
                      {(this.state.reActivateEmployeeData.isprocessefnf ==
                        false ||
                        this.state.reActivateEmployeeData.isprocessefnf ==
                          null || (this.state.reActivateEmployeeData.isprocessefnf ==
                            true && this.state.reActivateEmployeeData.fnfprocsseddate == null )) && (
                        <Button
                          className="margin-top-24 btn btn-primary-md-blue margin-right-16"
                          color="primary"
                          onClick={this.onReActivate}
                          variant="contained"
                        >
                          Re-activate
                        </Button>
                      )}
                      <Button
                        className="margin-top-24 btn btn-trans"
                        color="primary"
                        onClick={() =>
                          this.setState({ reactivateDrawer: false })
                        }
                        variant="contained"
                      >
                        Cancel
                      </Button>
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
        </Drawer>
        <Drawer
          anchor="right"
          open={this.state.resetPasswordDrawer}
          onClose={() => this.setState({ resetPasswordDrawer: false })}
          classes={{
            paper: classNames(classes.drawerPaper),
          }}
        >
          <div style={{ padding: 16 }}>
            <DrawerHeader
              header={`Set password for ${fullname}`}
              isbackarrow={false}
              closeDrawer={() =>
                this.setState({
                  resetPasswordDrawer: false,
                  isnotify: false,
                  showPassword: false,
                  newpassword: null,
                })
              }
            />
            {this.state.resetPasswordDrawer && (
              <div className="margin-bottom-20">
                <p className="extra-small-dark-disabled margin-bottom-4">
                  <span>Password</span>
                </p>
                <TextField
                  id="password"
                  className={classNames(classes.dense, "width100")}
                  margin="dense"
                  variant="outlined"
                  type={this.state.showPassword ? "text" : "password"}
                  value={this.state.newpassword}
                  //  onFocus={this.SetHelperTextFlag.bind(
                  //    this,
                  //    "password",
                  //  )}
                  onChange={(value) => {
                    this.handleChange(value, "newpassword");
                  }}
                  //  onBlur={this.ValidateField.bind(
                  //    this,
                  //    "password",
                  //    "password",
                  //  )}
                  //  error={
                  //    this.state.errors.password &&
                  //    this.state.fields.password.length < 8
                  //  }
                  // onKeyPress={this.passwordKeyPress.bind(this)}
                  inputProps={{ maxLength: 256 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          className="ShowPassword"
                          aria-label="Toggle password visibility"
                          onClick={this.handleClickShowPassword}
                        >
                          {this.state.showPassword ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />

                {/* {!!this.state.errors.password &&
               !this.state.helperText.password ? (
                 <span className="caption-error">
                   <FormattedMessage
                     id="Erpassword"
                     defaultMessage="Minimum 8 characters, please 🙏"
                   />
                 </span>
               ) : (
                 ""
               )}

               {this.state.helperText.password ? (
                 <span className="caption-helptest">
                   <FormattedMessage
                     id="Htpassword"
                     defaultMessage=" The password you used during signup goes here 🔑"
                   />
                 </span>
               ) : (
                 ""
               )} */}
                <div style={{ marginTop: 16 }}>
                  <DynamicForm
                    fields={checkboxinputconverter({
                      value: this.state.isnotify,
                      placeholder: "",
                      label: "Notify employee",
                    })}
                    onChange={(value) => {
                      this.handleChange(value, "isnotify");
                    }}
                  />
                </div>
                <Button
                  className="margin-top-24 btn btn-primary-md-blue margin-right-16"
                  color="primary"
                  onClick={this.onResetPassword}
                  variant="contained"
                >
                  Save
                </Button>
                <Button
                  className="margin-top-24 btn btn-trans"
                  color="primary"
                  onClick={() =>
                    this.setState({
                      resetPasswordDrawer: false,
                      isnotify: false,
                      showPassword: false,
                      newpassword: null,
                    })
                  }
                  variant="contained"
                >
                  Cancel
                </Button>
              </div>
            )}
          </div>
        </Drawer>

      </div>
    );
  }
}

EmpActions.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  refreshProfileInfoReducer: state.refreshProfileInfoReducer,
  SubscriptionData: state.SubscriptionInfo.SubscriptionData,
  AuthenticationAction: state.AuthenticationAction,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      refreshProfileInfo: (data) => refreshProfileInfo(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(EmpActions)));
